
<template>
    
  <div>
        
    <div
      :class="{ active: measureActive, measureActives: measureActives }"
      @click="toggleMeasure"
    >
      <img src="/static/images/celiang.png" alt="" />
       
    </div>
  </div>
</template>
        
<script>
import * as THREE from "three";
import Bus from "../../utils/bus.js";
import { mapMutations } from "vuex";
import { mapState } from "vuex";
import { CSS2DObject } from "three/addons/renderers/CSS2DRenderer.js";
export default {
  data() {
    return {
      raycaster: new THREE.Raycaster(),
      mouse: new THREE.Vector2(),
      points: [],
      measureActive: false,
      measureActives: "measureActives",
      markers: [],
      lines: [],
      renderer: null,
      labelRenderer: null,
      distanceDisplays: null,
      earthLabel: null,
      count: 1,
      distances:false
    };
  },
  computed:{
    ...mapState(["toolDistance"]),
  },
  watch:{
    toolDistance:{
      handler(news,old){
        this.distances= news
        if(!this.distances){
          this.measureActive=false
        }
    }
    }
  
  },
  mounted() {
    this.renderer = this.$store.state.rendererRef;

    this.labelRenderer = this.$store.state.labelRenderer;
    this.addEventListeners();
  },
  methods: {
    ...mapMutations(["setToolDistance","setToolAngle","setToolLabels"]),

    addEventListeners() {
      this.renderer[0].domElement.addEventListener("click", this.onMouseClick);
    },

    onMouseClick(event) {
      if (!this.measureActive) return;
      if(!this.distances)  return
    
      const canvasContainer = this.renderer[0].domElement;
      const canvasPosition = canvasContainer.getBoundingClientRect();

      this.mouse.x =
        ((event.clientX - canvasPosition.left) / canvasPosition.width) * 2 - 1;
      this.mouse.y =
        -((event.clientY - canvasPosition.top) / canvasPosition.height) * 2 + 1;

      this.raycaster.setFromCamera(this.mouse, this.renderer[1]);

      const intersects = this.raycaster.intersectObjects(
        this.$store.state.meshList,
        true
      );

      if (intersects.length > 0) {
        // 添加一个点\

        const pointGeometry = new THREE.SphereGeometry(2);
        const pointMaterial = new THREE.MeshBasicMaterial({ color: "black" });
        const point = new THREE.Mesh(pointGeometry, pointMaterial);
        const mark = intersects[0].point;
        point.position.copy(mark);
        this.markers.push(mark);
        this.renderer[2].add(point);
        this.points.push(point);
        if (this.markers.length == 2) {
          this.lines.push(this.points);

          // 在屏幕上显示点击位置的坐标
          var point1 = intersects[0].point;
          let vector = new THREE.Vector3(point1.x, point1.y, point1.z);
          vector.project(this.renderer[1]);

          // 计算距离
          const distance = this.points[0].position.distanceTo(
            this.points[1].position
          );

          this.distanceDisplays = document.createElement("div");
          this.distanceDisplays.id = `${this.count++}`;
          this.distanceDisplays.innerText = `${distance.toFixed(2)}mm`;
          this.distanceDisplays.style.backgroundColor = "rgba(0, 0, 0, 0.5)";
          this.distanceDisplays.style.borderRadius = "6px";
          this.distanceDisplays.style.color = "yellow";
          this.distanceDisplays.style.fontSize = "10px";
          this.distanceDisplays.style.pointerEvents = "auto";
          this.earthLabel = new CSS2DObject(this.distanceDisplays);
          this.earthLabel.position.set(1.5, 0, 0);
          // this.earthLabel.center.set(0, 1);
          this.points[1].add(this.earthLabel);
          this.distanceDisplays.addEventListener("click", (event) => {
            // 在点击事件处理函数中执行需要的操作
            const ids = event.target.id - 1;
            const points1 = this.lines[ids];
            Bus.$emit("eventDIV", [event, line, points1]);
          });
          const animate = () => {
            this.renderer[0].render(this.renderer[2], this.renderer[1]);
            this.labelRenderer.render(this.renderer[2], this.renderer[1]);
            requestAnimationFrame(animate);
          };
          animate();
          // 添加线
          const vertices = new Float32Array([
            this.points[0].position.x,
            this.points[0].position.y,
            this.points[0].position.z,
            this.points[1].position.x,
            this.points[1].position.y,
            this.points[1].position.z,
          ]);
          const lineGeometry = new THREE.BufferGeometry();
          lineGeometry.setAttribute(
            "position",
            new THREE.BufferAttribute(vertices, 3)
          );
          const lineMaterial = new THREE.LineBasicMaterial({ color: "black", linewidth: 8  });
          const line = new THREE.Line(lineGeometry, lineMaterial);
          this.renderer[2].add(line);
          this.markers = [];
          this.points = [];
        }
      }
    },

    toggleMeasure() {
      this.setToolAngle(false)
      this.setToolDistance(true)

      this.setToolLabels(false)
      this.measureActive = !this.measureActive;

      const canvasContainer = this.renderer[0].domElement;

      if (this.measureActive) {
        canvasContainer.style.cursor = "crosshair";
      } else {
        canvasContainer.style.cursor = "auto";

        /*  */
      }
    },
  },
};
</script> 
        
        <style scoped lang="scss">
.measureActives {
  width: 35px;
  height: 35px;
  > img {
    width: 100%;
    height: 100%;
  }
}
</style> 